/**
 * Copyright © 2012 Goodgame Studios. All rights reserved.
 *
 * Created with IntelliJ IDEA
 * Creator: pburst
 * Created: 20.06.13, 18:00
 *
 * $URL: $
 * $Rev: $
 * $Author: $
 * $Date: $
 * $Id: $
 */


import Event = createjs.Event;

export class IdentityManagementEvent extends Event {
    public static ID_MANAGEMENT_ACTIVE: string = "idMangementActive";
    public static ID_MANAGEMENT_INCTIVE: string = "idMangementInactive";

    constructor(type: string, bubbles: boolean = false, cancelable: boolean = false) {
        super(type, bubbles, cancelable);
    }
}

